import {useEffect, useRef} from 'react';
import {useSearchParams} from 'react-router-dom';
import {useWorkspace} from '../workspace/WorkspaceContext';
import {consumeGmailOutcome} from '../services/gmailOutcome';

export function useGmailOutcome(): void {
  const {refresh} = useWorkspace();
  const [params, setParams] = useSearchParams();
  const result = params.get('gmail');
  const handled = useRef<string | null>(null);
  useEffect(() => {
    consumeGmailOutcome({result, refresh, setParams, handled});
  }, [result, refresh, setParams]);
}